import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useFeatureEnabled } from '@/lib/entitlements';
import type { FeatureKey } from './types';

interface FeatureRouteProps {
  feature: FeatureKey;
  children: ReactNode;
}

/** Blocks direct navigation to a module the current plan doesn't include. */
export function FeatureRoute({ feature, children }: FeatureRouteProps) {
  const isEnabled = useFeatureEnabled();
  if (isEnabled(feature)) return <>{children}</>;

  return (
    <div className="page">
      <p className="text-xs uppercase tracking-[0.3em] text-brand-orange-500">Upgrade required</p>
      <h1 className="h-display mt-2 text-4xl">Not included in your plan.</h1>
      <p className="mt-3 max-w-md text-sm text-brand-navy-500">
        This module isn’t enabled for your organization’s Orbis subscription. Ask your administrator
        to change plans in Azure Marketplace.
      </p>
      <Link
        to="/home"
        className="mt-6 inline-flex h-10 items-center justify-center rounded-xl bg-gradient-brand-navy px-4 text-sm font-medium text-white hover:opacity-95"
      >
        Back to home
      </Link>
    </div>
  );
}
